// extracted by mini-css-extract-plugin
export default {"main_content":"index_main_content_yEZC7"};